
import { ForwardedRef, forwardRef, Fragment, useEffect, useRef, useState } from 'react';
import ReportDrawer from '../../../constants/ReportDrawer';
import SidebarOpen from '../../../constants/SidebarOpen';
import { useSidebar } from '../../../helpers/sidebarClose';
import CircleBtn from '../../../constants/CircleBtn';
import ReportHeader from '../../../constants/ReportHeader';
import { useReactToPrint } from "react-to-print";
import TrialRptFormView from '../../../components/account/reports/trial_rpt/TrialRptFormView';
import TrialRptListView from '../../../components/account/reports/trial_rpt/TrialRptListView';
import PrintTrialRptView from '../../../components/account/reports/trial_rpt/PrintTrialRptView';

const TrialReportCreateListView = ({ setIconsButton }: { setIconsButton: any }) => {
    const { isOpen, toggleSidebar, closeSidebar } = useSidebar('trial_rpt');
    useEffect(() => {
        setIconsButton(<CircleBtn onClick={handlePrintCard} />);
        return () => {
            setIconsButton(null);
        };
    }, []);
    const [onTrialReport, setOnTrialReport] = useState([]);

    const componentListRef = useRef<HTMLDivElement | null>(null);
    // ForwardRef component definition with TypeScript
    const RenderListComponent = forwardRef<HTMLDivElement>(
        (props, ref: ForwardedRef<HTMLDivElement>) => {
            return (
                <div ref={ref}>
                    <PrintTrialRptView onTrialReport={onTrialReport} />
                </div>
            );
        }
    );
    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current!,
    });
    useEffect(() => {
        // Open the sidebar only if it's not already open
        if (!isOpen) {
            toggleSidebar();
        }
    }, [isOpen, toggleSidebar]);
    return (
        <Fragment>
            <SidebarOpen onClick={toggleSidebar} />
            <ReportDrawer header={<ReportHeader label='Trial Report' />} open={isOpen} onClose={toggleSidebar}>
                <TrialRptFormView setOnTrialReport={setOnTrialReport} />
            </ReportDrawer>
            <TrialRptListView onTrialReport={onTrialReport} />
            <div className='hidden'>
                <div ref={componentListRef}>
                    <RenderListComponent />
                </div>
            </div>
        </Fragment>
    )
}

export default TrialReportCreateListView